// ─────────────────────────────────────────────────────────────────────────────
//  config.js — Configuration globale de l'application
//
//  Pourquoi ce fichier existe ?
//  Toutes les valeurs qui changent selon l'environnement (dev, mainnet)
//  sont centralisées ici. Un seul endroit à modifier.
//
//  Surcharge par localStorage (console navigateur) :
//    localStorage.setItem('pros_rpc_url', 'https://...')    → RPC custom
//    localStorage.setItem('pros_cluster', 'mainnet-beta')   → bascule mainnet
//    localStorage.setItem('pros_worker_url', 'https://...')  → Worker custom
// ─────────────────────────────────────────────────────────────────────────────

// Mode debug runtime (explicite) :
// - activé automatiquement en dev locale (localhost / 127.0.0.1)
// - activable ailleurs via ?debug=1
const _HOST = window.location.hostname;
const _DEBUG_QUERY = new URLSearchParams(window.location.search).get('debug');
export const runtimeDebug = _HOST === 'localhost'
  || _HOST === '127.0.0.1'
  || _DEBUG_QUERY === '1';

// Les overrides localStorage sont autorisés uniquement en mode debug
const getOverride = (key) => runtimeDebug ? localStorage.getItem(key) : null;

console.debug(`[config] runtimeDebug=${runtimeDebug ? 'ON' : 'OFF'} (host=${_HOST})`);

// Réseau actif
const CLUSTER = getOverride('pros_cluster') || 'devnet';

// ── URL du Cloudflare Worker RPC proxy ───────────────────────────────────────
//
// Le Worker proxy injecte la clé Helius côté serveur (clé jamais visible ici).
// Avantages vs RPC public :
//   - Rate limits élevés (Helius : 100 req/s → 1000 req/s selon plan)
//   - getProgramAccounts activé en mainnet (désactivé sur les RPCs publics)
//   - Latence plus faible (edge Cloudflare proche de l'utilisateur)
//
// Worker : https://pros-site.prosartonsolana.workers.dev
// Routes : POST /       → proxy RPC Helius
//          POST /admin  → opérations admin signées (update_authority)
const WORKER_URL = getOverride('pros_worker_url')
  || 'https://pros-site.prosartonsolana.workers.dev';

// Priorité : localStorage (rpc_url explicite) > Worker > RPC public fallback
const RPC_URL = getOverride('pros_rpc_url')
  || WORKER_URL
  || (CLUSTER === 'mainnet-beta'
    ? 'https://api.mainnet-beta.solana.com'
    : 'https://api.devnet.solana.com');

export const config = {
  // ── Réseau ────────────────────────────────────────────────────────────────
  cluster:   CLUSTER,
  rpcUrl:    RPC_URL,
  workerUrl: WORKER_URL,  // exposé pour diagnostic (ex: afficher dans admin)

  // ── Programme Anchor ──────────────────────────────────────────────────────
  // V3 scaffold multi-collection / multi-epoch.
  programId: 'DRfkEv7CkNMtkjaQNZS2GWsVict4VKccwfiqSx7kzSPg',
  collectionId: 1,
  launchEpoch: 1,

  // ── Address Lookup Table (ALT) ────────────────────────────────────────────
  // Requis pour pack ×5+ (économise ~14×32 = 448 bytes sur les comptes fixes).
  // Créer avec : node scripts/create-alt.js
  // null = pas d'ALT (pack ×3 max sans ALT, ~1100 bytes)
  altAddress: null,

  // Wallet admin
  adminWallet: '2N9hAofyF88Xac92fEKojmV93cK7P7qmD7T6p47my3YH',

  // ── Collection ────────────────────────────────────────────────────────────
  symbol:      'PROS',
  totalSupply: 10_000,

  // ── Assets ────────────────────────────────────────────────────────────────
  // Toujours servis depuis Cloudflare R2 (dev + prod).
  // Les 10 000 SVG/JSON ne sont pas dans le repo — R2 est la seule source.
  assetsBase: 'https://pub-86cc27ada1fc47c890b9071ad5589d88.r2.dev/',
  indexUrl:   'https://pub-86cc27ada1fc47c890b9071ad5589d88.r2.dev/index.json',

  // ── Hashes pré-calculés (V1 SVG SHA-256) ─────────────────────────────────
  // Table { "0000": "hex...", ... } générée par scripts/nft-prepare-e2e.js.
  // Utilisée par le client mint pour connaître le hash V1 sans télécharger chaque SVG.
  // Immuable après le premier mint — changer les SVGs invalide les NftState on-chain.
  hashesUrl: 'https://pub-86cc27ada1fc47c890b9071ad5589d88.r2.dev/hashes.json',
};
